'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBlind = function FaBlind(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.7 6.9q-1.5 0-2.5-1t-1-2.4q0-1.5 1-2.5t2.5-1 2.4 1 1 2.5q0 1.4-1 2.4t-2.4 1z m12.3 14.4q0 1.1-0.7 1.5t-1.4 0.1-1.1-0.7l-8.2-9.8q-0.1-0.3-0.3-0.4t-0.2 0l-0.1 0.1q-0.2 0.2 0.1 0.4l2.7 3.1 0 8-3.6 10.2q-1.5 4.2-2 5.2-0.4 0.6-0.6 0.7-1.2 0.6-2.3 0-0.7-0.3-1-0.9t-0.2-1.3q0.1-0.4 4.4-13.8l0.1-9.3-1.9 3.7 0.8 4.9q0.1 0.6 0 1t-0.3 0.6-0.4 0.3-0.4 0.2l-0.2 0q-0.4 0.1-0.7 0t-0.6-0.4-0.3-0.5-0.2-0.4 0-0.2l-1-6.7 4.7-8.5q0.5-0.8 2.5-0.8 1.7 0 2.4 0.9l9.5 11.7q0.1 0.1 0.3 0.3l0 0.1 0 0q0.2 0.3 0.2 0.7z m-9 3.3q0.9 2.5 1.9 5t1.6 3.8l0.5 1.2q0.8 2.1 1 2.8 0.2 1.6-0.8 2.2-0.8 0.5-1.5 0.3t-1.1-0.5-0.7-0.7h0q-0.1-0.4-0.2-0.6l-2.8-7.8z m18.4 13.2q0.7 1.1 0.7 1.3 0 0.1-0.1 0.2-0.2 0.1-0.3 0t-0.4-0.6-0.3-0.7q-2.6-3.8-9.5-14.8 0.1 0.1 0.2 0t0.1-0.1l0.1 0q0.2-0.2 0.2-0.4z' })
        )
    );
};

exports.default = FaBlind;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/blind.js
// module id = 1213
// module chunks = 0